import { useContext } from "react";

import { ViewerContext, ViewerContextType } from "@/context/viewer/context";

export const useViewerContext: () => ViewerContextType = () => {
    const context = useContext(ViewerContext);

    if (!context) {
        throw new Error("useViewerContext must be used within a ViewerContextProvider");
    }

    return context;
};
